import { css } from "@emotion/react";
import bgSignin from "assets/common/modal/bgAuth-signin.png";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

const SignInPageStyle = {
  wrapper: css`
    background: url(${bgSignin});
    background-size: 110% 110%;
    background-position: center center;
    background-color: #ccdae1;
    padding: 0 0.75rem;

    height: 100vh;

    ${media["2sm"]} {
      height: 100%;
      min-height: 100vh;
    }
  `,

  header: css`
    position: relative;
  `,

  headerLogo: css`
    text-align: center;
    img {
      width: 100%;
      height: 120px;
      object-fit: contain;
    }
  `,

  headerTextBox: {
    index: css`
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    `,

    text: css`
      h2 {
        margin: 0 0 8px;
        font-size: 14px;
        color: ${theme.colors.orange[200]};
      }
      p {
        color: ${theme.colors.orange[200]};
        margin: 0;
        font-size: 13px;
        font-weight: 300;
      }
    `,

    groupImg: css`
      display: flex;
      align-items: center;
      justify-content: center;

      margin-left: 2.5%;

      img {
        max-height: 100px;
        &:first-of-type {
          width: 52px;
          border-right: 1px solid ${theme.colors.orange[200]};
          padding-right: 10px;
        }
        &:last-of-type {
          max-width: 150px;
          padding-left: 10px;
        }
      }
    `,
  },

  form: css`
    margin-top: 30px;

    & .ant-form-item-control-input {
      & .ant-input-affix-wrapper {
        height: 34px !important;
      }
    }

    .ant-form-item {
      margin-bottom: 24px !important;
    }
  `,

  formNotice: css`
    margin: 0 0 12px;
    line-height: 1.5rem;
    font-size: 1.125rem;
    text-align: center;
  `,

  textRegister: css`
    text-align: center;
    margin-bottom: 2.5rem;
    font-size: 16px;

    p {
      color: ${theme.colors.black};
    }
    span {
      color: ${theme.colors.orange[200]};
    }
  `,

  groupTextbox: {
    index: css`
      display: flex;
      align-items: center;
      justify-content: center;

      gap: 30px;

      padding: 12px 0 25px;
    `,

    item: css`
      height: 62px;
      margin: 0;

      border-radius: 10px;
      background-color: ${theme.colors.orange[0]};
      color: ${theme.colors.orange[200]};

      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      padding: 0 15px;

      p {
        font-size: 14px;
        font-weight: 500;
        text-transform: uppercase;

        margin: unset !important;
        ${media.sm} {
          font-size: 12px;
        }
      }
    `,
  },

  btnLogin: css`
    margin: 1.5rem 0;
    button {
      height: 40px;

      width: 100%;
      text-align: center;
      font-size: 18px;
      font-weight: 700;
      text-transform: uppercase;
      border-radius: 50px;
      color: white;
      background-color: ${theme.colors.orange[200]};

      span {
        font-weight: 400;
        font-size: 16px;
      }
    }
  `,

  btnCaptcha: css`
    height: 100%;

    display: flex;
    align-items: center;
    gap: 3px;

    margin-right: 5px;
    span {
      width: 100%;
      text-align: center;
    }
    svg {
      fill: #4486a4;
    }
  `,

  btnClose: css`
    position: absolute;
    right: -1px;
    top: 6px;

    font-size: 24px;
    color: ${theme.colors.orange[200]};
    text-decoration: none;
  `,

  blockCaptcha: (background: string) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 27px;

    background-image: url(${background});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;

    span {
      font-size: 20px;
      opacity: 0.6;
      font-style: italic;
    }
  `,
};

export default SignInPageStyle;
